import { UpdateProductSequencePayload } from "../product-list/ProductListTypes";

export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const REMOVE_SNACKBAR = "REMOVE_SNACKBAR";

export interface ShowSnackbarPayload {
  message: string;
  variant: "success" | "error" | "warning" | "info";
  categoryId?: string;
  errorMessage?: string;
  retryPayload?: UpdateProductSequencePayload;
  key?: string; // Unique key for the snackbar
}

export interface RemoveSnackbarPayload {
  key: string;
}

interface ShowSnackbarAction {
  type: typeof SHOW_SNACKBAR;
  payload: ShowSnackbarPayload;
}

interface RemoveSnackbarAction {
  type: typeof REMOVE_SNACKBAR;
  payload: RemoveSnackbarPayload;
}

export type SnackbarActionTypes = ShowSnackbarAction | RemoveSnackbarAction;
